
import React from "react";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

const Mission = () => {
  const navigate = useNavigate();

  return (
    <main className="min-h-[100dvh] flex flex-col items-center justify-between p-6 gradient-background">
      <div className="flex-1 flex flex-col items-center justify-center text-center space-y-8 py-12">
        <h1 className="text-4xl md:text-5xl font-bold text-black max-w-4xl animate-fade-up opacity-0" style={{ animationDelay: "0.2s" }}>
          We can't wait to show you how it works, but we think it's important that you know why
        </h1>
        
        <p className="text-lg md:text-xl text-black max-w-3xl animate-fade-up opacity-0" style={{ animationDelay: "0.3s" }}>
          EatsBoost was built to support and empower local restaurants—the champions of our communities. These are the people who do it for the smiles and for the love of sharing their passion—not for corporate profits. They might not have the resources or technical know-how to develop sophisticated loyalty apps, yet they deserve the same tools to grow and connect deeply with their customers.
        </p>
        
        <p className="text-lg md:text-xl text-black max-w-3xl animate-fade-up opacity-0" style={{ animationDelay: "0.4s" }}>
          That's why EatsBoost provides local restaurants with the powerful benefits of modern loyalty technology, making it easier for them to reward your support and enhance your dining experience.
        </p>
        
        <p className="text-2xl md:text-3xl font-bold text-black animate-fade-up opacity-0" style={{ animationDelay: "0.5s" }}>
          Support Local. Choose Local.
        </p>
      </div>
      
      <Button 
        className="animate-fade-up opacity-0 bg-white text-black hover:bg-gray-100"
        style={{ animationDelay: "0.6s" }}
        onClick={() => navigate("/how-it-works")}
      >
        How it Works
        <ArrowRight className="ml-2" />
      </Button>
    </main>
  );
};

export default Mission;
